import { http } from "config/http";


export const addParamsConfig = async (body: any) => {
    const destinationObject = { ...body, client_env: body.client_name };
    try {
        const res: any = await http.post('client_info_store', destinationObject);
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}

export const getClientInfo = async (env: any, is_fe: boolean) => {
    try {
        const res: any = await http.get(`get_client_info?client_name=${env}&is_fe=${is_fe}`)
        return { result: res?.data }
    } catch (error: any) {

        return { error: error.message }
    }
}


export const getClientVersions = async (env: any) => {
    try {
        const res: any = await http.get(`get_all_clients_version_history?client_name=${env}`)
        return { result: res?.data }
    } catch (error: any) {

        return { error: error.message }
    }
}

export const getClientByVersion = async (env: any, version: string) => {
    try {
        const res: any = await http.get(`get_client_by_version?client_name=${env}&version=${version}`)
        return { result: res?.data }
    } catch (error: any) {

        return { error: error.message }
    }
}